import { render, staticRenderFns } from "./KeFuPage.vue?vue&type=template&id=5eeb6624&"
import script from "./KeFuPage.vue?vue&type=script&lang=js&"
export * from "./KeFuPage.vue?vue&type=script&lang=js&"
import style0 from "./KeFuPage.vue?vue&type=style&index=0&id=5eeb6624&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports